 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		10: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		10: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"styles","2":"dd7e2b466708121634c0d8ccfa2a7c76624c8052","3":"f04782ff98f6208088879702ded0d707e23331c2","4":"4cc0fc39e44279812af682ac1f0b759689aa589a","5":"7ef7d737cfa39b5ef08ea784d36ec992231363f8","6":"410b946779ff4b3ecf190183806d0b4c9606254b","7":"69890eb479c0fa6dc3d1a00c02628929d4a8a28e","8":"88386410e34da00c3739ad956a6f5aaddc95b301","9":"adc1170271244a3accb9a15c1ce4e7030a671b5b","13":"component---src-pages-approach-js","14":"component---src-pages-become-a-carer-js","15":"component---src-pages-blog-js","16":"component---src-pages-condition-cancer-js","17":"component---src-pages-condition-dementia-js","18":"component---src-pages-condition-multiple-sclerosis-js","19":"component---src-pages-condition-parkinsons-js","20":"component---src-pages-condition-stroke-js","21":"component---src-pages-cookies-js","22":"component---src-pages-cta-js","23":"component---src-pages-index-js","24":"component---src-pages-liveincare-js","25":"component---src-pages-liveincare-looking-for-care-js","26":"component---src-pages-our-carers-js","27":"component---src-pages-our-team-js","28":"component---src-pages-partner-with-us-js","29":"component---src-pages-pricing-js","30":"component---src-pages-privacy-js","31":"component---src-pages-privacy-version-1-0-js","32":"component---src-pages-request-a-brochure-js","33":"component---src-pages-terms-and-conditions-js","34":"component---src-templates-blog-post-js","35":"component---src-templates-location-js"}[chunkId]||chunkId) + "-" + {"0":"387e736514345205e09e","1":"e9d24b1846c7d6eb9685","2":"c0846f5a1446654c859a","3":"ed2cb29ef66550395b65","4":"be12f689090dc3ecfe8d","5":"39ad738c11925988643f","6":"d71a33ab36bb74dec25d","7":"d3fefcb731be354202a0","8":"b04e7ce53eb350da73cd","9":"b1bab9fe1976110d65de","11":"34b6afa22ae6450f4f75","13":"958f7b67d74225836522","14":"b4924fef7d8fe841f8a4","15":"5cb8f2583706a017bca4","16":"4db10ad3659405feb693","17":"e5ace2a80fd0aad78144","18":"d4262aec0b72d381ad5b","19":"83e1356e8df1bbef6d74","20":"1842c75ee4045d285618","21":"d78ea4f79fa34225e3c1","22":"b4c8e48f236de451a3f0","23":"249fa404d46f76c455a3","24":"7370b716fcca7a2b0521","25":"dad2ba6d40da94710062","26":"9a1d8fb69f0073532040","27":"972a7294bd8389845efa","28":"8d5cff6bab53d814c060","29":"0073163a3078eb515b0d","30":"0dc0f4c07434a5337b31","31":"ad526cdae46e5d567649","32":"f03a131bb8e3ccb0725f","33":"b4895771dd7e9d3e4323","34":"0fbc392371c52c6e5d6f","35":"346d598b874e1d5a5a43","38":"2defa38da11db1e6debe","39":"63bfd90ae71d977bf6bb","40":"fabee23802dc3c52ad9c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"styles","2":"dd7e2b466708121634c0d8ccfa2a7c76624c8052","3":"f04782ff98f6208088879702ded0d707e23331c2","4":"4cc0fc39e44279812af682ac1f0b759689aa589a","5":"7ef7d737cfa39b5ef08ea784d36ec992231363f8","6":"410b946779ff4b3ecf190183806d0b4c9606254b","7":"69890eb479c0fa6dc3d1a00c02628929d4a8a28e","8":"88386410e34da00c3739ad956a6f5aaddc95b301","9":"adc1170271244a3accb9a15c1ce4e7030a671b5b","13":"component---src-pages-approach-js","14":"component---src-pages-become-a-carer-js","15":"component---src-pages-blog-js","16":"component---src-pages-condition-cancer-js","17":"component---src-pages-condition-dementia-js","18":"component---src-pages-condition-multiple-sclerosis-js","19":"component---src-pages-condition-parkinsons-js","20":"component---src-pages-condition-stroke-js","21":"component---src-pages-cookies-js","22":"component---src-pages-cta-js","23":"component---src-pages-index-js","24":"component---src-pages-liveincare-js","25":"component---src-pages-liveincare-looking-for-care-js","26":"component---src-pages-our-carers-js","27":"component---src-pages-our-team-js","28":"component---src-pages-partner-with-us-js","29":"component---src-pages-pricing-js","30":"component---src-pages-privacy-js","31":"component---src-pages-privacy-version-1-0-js","32":"component---src-pages-request-a-brochure-js","33":"component---src-pages-terms-and-conditions-js","34":"component---src-templates-blog-post-js","35":"component---src-templates-location-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"f5234cab1ce548684840","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
